import React, { useRef, useEffect } from 'react';
import anime from 'animejs/lib/anime.es.js';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();
  const toggleRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    // Animate theme toggle entrance
    anime({
      targets: toggleRef.current,
      opacity: [0, 1],
      scale: [0.8, 1],
      duration: 600,
      delay: 1000,
      easing: 'easeOutElastic(1, .8)'
    });
  }, []);

  const handleToggle = () => {
    // Animate the toggle switch
    anime({
      targets: iconRef.current,
      rotateY: [0, 180],
      scale: [1, 0.8, 1],
      duration: 400,
      easing: 'easeOutQuart',
      complete: () => {
        toggleTheme();
      }
    });

    // Animate the button press
    anime({
      targets: toggleRef.current,
      scale: [1, 0.95, 1],
      duration: 200,
      easing: 'easeOutQuad'
    });
  };

  return (
    <button
      ref={toggleRef}
      onClick={handleToggle}
      className={`fixed top-6 right-6 z-50 p-3 rounded-full transition-all duration-300 border-2 opacity-0 hover:scale-110 ${
        isDark
          ? 'bg-gray-800 border-white/20 text-white hover:border-green-400'
          : 'bg-white border-gray-900/20 text-gray-900 hover:border-green-400'
      }`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
    >
      <div ref={iconRef} className="w-5 h-5">
        {isDark ? <Sun size={20} /> : <Moon size={20} />}
      </div>
    </button>
  );
};

export default ThemeToggle;